/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

import React, { useCallback, useEffect } from 'react';
import { number, any } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { closeVideo, getConsultVideoRoom, logZoomEvent } from 'Redux/modules/webChat/actions';
import { addModal } from 'Redux/modules/modal/actions';
import RingtoneURL from 'Assets/audio/ringback_tone.mp3';

import DevicePermissionCheck from './DevicePermissionCheck/DevicePermissionCheck';
import ZoomContainer from './ZoomContainer';
import { useQueryDevice } from './hooks/useQueryDevice';
import { MediaPermissions } from './constants';
import { useAudio } from './hooks/useAudio';

function MainVideoContainer({ consultId, zoomClient }) {
  const dispatch = useDispatch();

  const roomInfo = useSelector(state => state.webChat.video.zoomInfo);

  const showError = useCallback(
    (message, onClose, closeText) => {
      dispatch(
        addModal({
          type: 'commonModal',
          id: 7,
          data: {
            title: 'Error',
            content: <div>{message}</div>,
            size: 'tiny',
            closeText,
            onClose: () => {
              if (onClose) {
                onClose();
              } else dispatch(closeVideo());
            },
          },
        }),
      );
    },
    [dispatch],
  );

  const { cameraPermission, micPermission } = useQueryDevice(showError);

  const onCancelVideo = useCallback(() => {
    dispatch(closeVideo());
  }, [dispatch]);

  const logEvents = body => {
    dispatch(logZoomEvent(body));
  };

  useEffect(() => {
    if (
      cameraPermission === MediaPermissions.PermissionGranted &&
      micPermission === MediaPermissions.PermissionGranted &&
      consultId
    ) {
      try {
        dispatch(getConsultVideoRoom(consultId));
      } catch (error) {
        onCancelVideo();
      }
    }
  }, [dispatch, consultId, cameraPermission, micPermission, onCancelVideo]);

  const audioRef = useAudio(RingtoneURL);

  if (
    cameraPermission === MediaPermissions.PermissionGranted &&
    micPermission === MediaPermissions.PermissionGranted &&
    roomInfo !== null
  )
    return (
      <ZoomContainer
        showError={showError}
        roomInfo={roomInfo}
        handleCloseVideo={onCancelVideo}
        zoomClient={zoomClient}
        audioRef={audioRef}
        logEvents={logEvents}
      />
    );

  return (
    <DevicePermissionCheck
      cameraPermission={cameraPermission}
      micPermission={micPermission}
      onClose={onCancelVideo}
    />
  );
}

MainVideoContainer.propTypes = {
  consultId: number.isRequired,
  zoomClient: any,
};

export default MainVideoContainer;
